import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { HttpParams } from '@angular/common/http';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';

@Component({
    selector: 'kiene-rechnung-email-dialog',
    templateUrl: './rechnung-email-dialog.component.html',
    styleUrls: ['./rechnung-email-dialog.component.scss'],
})
export class RechnungEmailDialogComponent implements OnInit {
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    bisCtrl = new UntypedFormControl(new Date(), [Validators.required]);
    vonCtrl = new UntypedFormControl([Validators.required]);
    anzahlBetroffenerRechnungen = 0;
    selectedFile: File;

    constructor(
        public dialogRef: MatDialogRef<RechnungEmailDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
    ) {}

    ngOnInit(): void {
        this.vonCtrl.valueChanges.subscribe({
            next: () => {
                this.gibAnzahlBetroffenerRechnungen();
            },
        });

        this.bisCtrl.valueChanges.subscribe({
            next: () => {
                this.gibAnzahlBetroffenerRechnungen();
            },
        });
    }

    gibAnzahlBetroffenerRechnungen() {
        if (!this.bisCtrl.valid || !this.vonCtrl.valid) {
            this.anzahlBetroffenerRechnungen = 0;
            return;
        }
        let params = new HttpParams();
        params = params.set('mail', 'null');
        params = params.set('artikel', '0');
        params = params.set('status_id[]', '53');
        params = params.append('status_id[]', '54');
        params = params.set('datum_von', (<Date>this.vonCtrl.value).toISOString());
        params = params.set('datum_bis', (<Date>this.bisCtrl.value).toISOString());
        this.api.get(this.apiBaseUrl + 'rechnung/read.php', params).subscribe({
            next: response => {
                this.anzahlBetroffenerRechnungen = response.count;
            },
        });
    }

    close() {
        this.dialogRef.close();
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files) {
            this.selectedFile = input.files[0];
        }
    }

    save() {
        const obj = { datum_von: this.vonCtrl.value, datum_bis: this.bisCtrl.value, file: this.selectedFile };

        this.dialogRef.close(obj);
    }

    openFileDialog() {
        this.fileInput?.nativeElement?.click();
    }
}
